/** Textul principal al cardului de fidelitate, comun tuturor temelor.
 * „o cafea gratuită” → „La 6 bonuri primești o cafea gratuită”;
 * o frază întreagă („La 7 produse cumpărate, primești unul gratuit”) rămâne cum e.
 */
export const LOYALTY_KICKER = 'Card de fidelitate';

export function loyaltyKicker(ls = {}) {
  return ls?.mode === 'ranking' ? 'Clasamentul clienților' : LOYALTY_KICKER;
}

export function loyaltyHeadline(ls = {}) {
  if (ls?.mode === 'ranking') {
    const p1 = String((Array.isArray(ls.rankPrizes) ? ls.rankPrizes[0] : '') || '').trim().replace(/[.!]+$/, '');
    return p1 ? `Locul 1 câștigă ${p1}` : 'Primii 3 clienți câștigă premii';
  }
  const raw = String(ls?.rewardText || '').trim().replace(/[.!]+$/, '');
  const required = Math.max(1, parseInt(ls?.requiredPurchases, 10) || 6);
  if (!raw) return `La ${required} bonuri primești o recompensă`;
  if (raw.length > 40 || /\d/.test(raw) || /primești|primesti/i.test(raw)) return raw;
  return `La ${required} bonuri primești ${raw}`;
}
